import React from "react";
import ChipIndicator from "./ChipIndicator";
import {useTranslation} from "react-i18next";

export default function Coverage(props) {

    const {t} = useTranslation();

    let esgReport = props.esgReport;

    // Coverage
    let covBar = '';
    if (esgReport && esgReport.rating && esgReport.rating.trim() !== "") {

        // 3 colors indicator
        let indColor = '';
        let label = '';
        if (esgReport.coverage >= 0.9) {
            indColor = 'coverage-high';
            label = t('high');
        } else if (esgReport.coverage >= 0.5) {
            indColor = 'coverage-medium';
            label = t('medium');
        } else if (esgReport.coverage > 0.0) {
            indColor = 'coverage-low';
            label = t('low');
        } else {
            // indColor = 'coverage-none';
            label = 'None';
        }
        label += ': ' + esgReport.covFmt;
        covBar = <ChipIndicator className={indColor} label={label}/>
    }

    return <>{covBar}</>;
}
